module.exports = () ->
  return {
    scope:
      breakdown:  "="
      currentTab: "="

    template: require('./manualSourceBreakdown.html')
  }
